import type {
  GrayNames,
  BlueNames,
  GreenNames,
  YellowNames,
  DangerNames,
  RedNames,
  PurpleNames,
  WhiteNames,
  ColorNames,
} from './types'

type AllColorNames =
  | GrayNames
  | BlueNames
  | GreenNames
  | YellowNames
  | DangerNames
  | RedNames
  | PurpleNames
  | ColorNames

export type Colors = Record<AllColorNames | WhiteNames, string> & {
  transparent: Record<AllColorNames, string>
}

const colors: Colors = {
  gray00: 'var(--gray00)',
  gray02: 'var(--gray02)',
  gray03: 'var(--gray03)',
  gray05: 'var(--gray05)',
  gray10: 'var(--gray10)',
  gray20: 'var(--gray20)',
  gray30: 'var(--gray30)',
  gray40: 'var(--gray40)',
  gray50: 'var(--gray50)',
  gray60: 'var(--gray60)',
  gray70: 'var(--gray70)',
  gray80: 'var(--gray80)',
  gray90: 'var(--gray90)',
  gray100: 'var(--gray100)',

  blue02: 'var(--blue02)',
  blue03: 'var(--blue03)',
  blue05: 'var(--blue05)',
  blue10: 'var(--blue10)',
  blue20: 'var(--blue20)',
  blue30: 'var(--blue30)',
  blue40: 'var(--blue40)',
  blue50: 'var(--blue50)',
  blue60: 'var(--blue60)',
  blue70: 'var(--blue70)',
  blue80: 'var(--blue80)',
  blue90: 'var(--blue90)',

  green02: 'var(--green02)',
  green03: 'var(--green03)',
  green05: 'var(--green05)',
  green10: 'var(--green10)',
  green20: 'var(--green20)',
  green30: 'var(--green30)',
  green40: 'var(--green40)',
  green50: 'var(--green50)',
  green60: 'var(--green60)',
  green70: 'var(--green70)',
  green80: 'var(--green80)',
  green90: 'var(--green90)',

  yellow02: 'var(--yellow02)',
  yellow03: 'var(--yellow03)',
  yellow05: 'var(--yellow05)',
  yellow10: 'var(--yellow10)',
  yellow20: 'var(--yellow20)',
  yellow30: 'var(--yellow30)',
  yellow40: 'var(--yellow40)',
  yellow50: 'var(--yellow50)',
  yellow60: 'var(--yellow60)',
  yellow70: 'var(--yellow70)',
  yellow80: 'var(--yellow80)',
  yellow90: 'var(--yellow90)',

  danger02: 'var(--danger02)',
  danger03: 'var(--danger03)',
  danger05: 'var(--danger05)',
  danger10: 'var(--danger10)',
  danger20: 'var(--danger20)',
  danger30: 'var(--danger30)',
  danger40: 'var(--danger40)',
  danger50: 'var(--danger50)',
  danger60: 'var(--danger60)',
  danger70: 'var(--danger70)',
  danger80: 'var(--danger80)',
  danger90: 'var(--danger90)',

  red02: 'var(--red02)',
  red03: 'var(--red03)',
  red05: 'var(--red05)',
  red10: 'var(--red10)',
  red20: 'var(--red20)',
  red30: 'var(--red30)',
  red40: 'var(--red40)',
  red50: 'var(--red50)',
  red60: 'var(--red60)',
  red70: 'var(--red70)',
  red80: 'var(--red80)',
  red90: 'var(--red90)',

  purple02: 'var(--purple02)',
  purple03: 'var(--purple03)',
  purple05: 'var(--purple05)',
  purple10: 'var(--purple10)',
  purple20: 'var(--purple20)',
  purple30: 'var(--purple30)',
  purple40: 'var(--purple40)',
  purple50: 'var(--purple50)',
  purple60: 'var(--purple60)',
  purple70: 'var(--purple70)',
  purple80: 'var(--purple80)',
  purple90: 'var(--purple90)',

  white02: 'var(--white02)',
  white03: 'var(--white03)',
  white05: 'var(--white05)',
  white10: 'var(--white10)',
  white20: 'var(--white20)',
  white30: 'var(--white30)',
  white40: 'var(--white40)',
  white50: 'var(--white50)',
  white60: 'var(--white60)',
  white70: 'var(--white70)',
  white80: 'var(--white80)',
  white90: 'var(--white90)',
  white100: 'var(--white100)',

  color02: 'var(--color02)',
  color03: 'var(--color03)',
  color05: 'var(--color05)',
  color10: 'var(--color10)',
  color20: 'var(--color20)',
  color30: 'var(--color30)',
  color40: 'var(--color40)',
  color50: 'var(--color50)',
  color60: 'var(--color60)',
  color70: 'var(--color70)',
  color80: 'var(--color80)',
  color90: 'var(--color90)',
  color100: 'var(--color100)',

  transparent: {
    gray00: 'var(--gray00a)',
    gray02: 'var(--gray02a)',
    gray03: 'var(--gray03a)',
    gray05: 'var(--gray05a)',
    gray10: 'var(--gray10a)',
    gray20: 'var(--gray20a)',
    gray30: 'var(--gray30a)',
    gray40: 'var(--gray40a)',
    gray50: 'var(--gray50a)',
    gray60: 'var(--gray60a)',
    gray70: 'var(--gray70a)',
    gray80: 'var(--gray80a)',
    gray90: 'var(--gray90a)',
    gray100: 'var(--gray100a)',

    blue02: 'var(--blue02a)',
    blue03: 'var(--blue03a)',
    blue05: 'var(--blue05a)',
    blue10: 'var(--blue10a)',
    blue20: 'var(--blue20a)',
    blue30: 'var(--blue30a)',
    blue40: 'var(--blue40a)',
    blue50: 'var(--blue50a)',
    blue60: 'var(--blue60a)',
    blue70: 'var(--blue70a)',
    blue80: 'var(--blue80a)',
    blue90: 'var(--blue90a)',

    green02: 'var(--green02a)',
    green03: 'var(--green03a)',
    green05: 'var(--green05a)',
    green10: 'var(--green10a)',
    green20: 'var(--green20a)',
    green30: 'var(--green30a)',
    green40: 'var(--green40a)',
    green50: 'var(--green50a)',
    green60: 'var(--green60a)',
    green70: 'var(--green70a)',
    green80: 'var(--green80a)',
    green90: 'var(--green90a)',

    yellow02: 'var(--yellow02a)',
    yellow03: 'var(--yellow03a)',
    yellow05: 'var(--yellow05a)',
    yellow10: 'var(--yellow10a)',
    yellow20: 'var(--yellow20a)',
    yellow30: 'var(--yellow30a)',
    yellow40: 'var(--yellow40a)',
    yellow50: 'var(--yellow50a)',
    yellow60: 'var(--yellow60a)',
    yellow70: 'var(--yellow70a)',
    yellow80: 'var(--yellow80a)',
    yellow90: 'var(--yellow90a)',

    danger02: 'var(--danger02a)',
    danger03: 'var(--danger03a)',
    danger05: 'var(--danger05a)',
    danger10: 'var(--danger10a)',
    danger20: 'var(--danger20a)',
    danger30: 'var(--danger30a)',
    danger40: 'var(--danger40a)',
    danger50: 'var(--danger50a)',
    danger60: 'var(--danger60a)',
    danger70: 'var(--danger70a)',
    danger80: 'var(--danger80a)',
    danger90: 'var(--danger90a)',

    red02: 'var(--red02a)',
    red03: 'var(--red03a)',
    red05: 'var(--red05a)',
    red10: 'var(--red10a)',
    red20: 'var(--red20a)',
    red30: 'var(--red30a)',
    red40: 'var(--red40a)',
    red50: 'var(--red50a)',
    red60: 'var(--red60a)',
    red70: 'var(--red70a)',
    red80: 'var(--red80a)',
    red90: 'var(--red90a)',

    purple02: 'var(--purple02a)',
    purple03: 'var(--purple03a)',
    purple05: 'var(--purple05a)',
    purple10: 'var(--purple10a)',
    purple20: 'var(--purple20a)',
    purple30: 'var(--purple30a)',
    purple40: 'var(--purple40a)',
    purple50: 'var(--purple50a)',
    purple60: 'var(--purple60a)',
    purple70: 'var(--purple70a)',
    purple80: 'var(--purple80a)',
    purple90: 'var(--purple90a)',

    color02: 'var(--color02a)',
    color03: 'var(--color03a)',
    color05: 'var(--color05a)',
    color10: 'var(--color10a)',
    color20: 'var(--color20a)',
    color30: 'var(--color30a)',
    color40: 'var(--color40a)',
    color50: 'var(--color50a)',
    color60: 'var(--color60a)',
    color70: 'var(--color70a)',
    color80: 'var(--color80a)',
    color90: 'var(--color90a)',
    color100: 'var(--color100a)',
  },
}

export default colors
